var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRollux1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1046,
    height: 1046,
    viewBox: "0 0 1046 1046",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M522.711 1045.77C811.397 1045.77 1045.42 811.747 1045.42 523.061C1045.42 234.376 811.397 0.350098 522.711 0.350098C234.026 0.350098 0 234.376 0 523.061C0 811.747 234.026 1045.77 522.711 1045.77Z",
    fill: "#DBEF88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M276.761 277.111H296.31L765.162 706.901V765.512H276.761V277.111Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M646.493 560.67C659.921 534.184 667.489 504.21 667.489 472.456C667.489 364.545 580.017 277.111 472.143 277.111C434.343 277.111 399.065 287.869 369.166 306.454L646.493 560.67Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollux1);
export default __webpack_public_path__ + "static/media/Rollux-1.1da368f2772c36e922d3dc7029db9afa.svg";
export { ForwardRef as ReactComponent };